import { render, staticRenderFns } from "./WChip.vue?vue&type=template&id=5d25975c&"
import script from "./WChip.vue?vue&type=script&setup=true&lang=js&"
export * from "./WChip.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports